import { render, staticRenderFns } from "./VCategoriesList.vue?vue&type=template&id=52126e37"
import script from "./VCategoriesList.vue?vue&type=script&lang=js"
export * from "./VCategoriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports